module.exports = __webpack_public_path__ + "static/media/magazineTupp_01_thumb_hover.242af50b.png";